// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Exchange Wallet Management */
.exwallet-section {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border);
  overflow: hidden;
  margin-bottom: 1.5rem;
}

.exwallet-section:last-child {
  margin-bottom: 0;
}

.exwallet-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);
  border-bottom: 1px solid var(--border);
}

.exwallet-section__title-wrap {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.exwallet-section__icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.15);
  color: #0f766e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

.exwallet-section__title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text);
}

.exwallet-section__stats {
  display: flex;
  gap: 1.25rem;
}

.exwallet-section__subtitle {
  margin: 0;
  padding: 0 1.5rem 1rem;
  font-size: 0.9rem;
  color: var(--text-muted);
}

/* Toolbar: chain form + search in one row */
.exwallet-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid var(--border);
}

/* Chain list form: dropdown + input + Submit */
.exwallet-chain-form {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.exwallet-chain-select {
  padding: 0.6rem 2rem 0.6rem 1rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
  cursor: pointer;
  min-width: 140px;
}

.exwallet-chain-select:focus {
  outline: none;
  border-color: #0f766e;
}

.exwallet-chain-input {
  padding: 0.6rem 1rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
  min-width: 160px;
}

.exwallet-chain-input::placeholder {
  color: var(--text-muted);
}

.exwallet-chain-input:focus {
  outline: none;
  border-color: #0f766e;
}

.exwallet-chain-submit {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: inherit;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(15, 118, 110, 0.3);
  transition: opacity 0.2s;
}

.exwallet-chain-submit:hover {
  opacity: 0.95;
}

.exwallet-stat {
  font-size: 0.875rem;
  color: var(--text-muted);
}

.exwallet-stat strong {
  color: #0f766e;
  font-weight: 700;
  margin-right: 0.25rem;
}

.exwallet-search-wrap {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  flex: 1 1;
  min-width: 220px;
  max-width: 360px;
}

.exwallet-search-wrap i {
  color: var(--text-muted);
  font-size: 0.9rem;
}

.exwallet-search-input {
  flex: 1 1;
  min-width: 0;
  max-width: 320px;
  padding: 0.55rem 0.75rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
}

.exwallet-search-input::placeholder {
  color: var(--text-muted);
}

.exwallet-search-input:focus {
  outline: none;
  border-color: #0f766e;
}

.exwallet-table-wrap {
  overflow-x: auto;
}

.exwallet-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.exwallet-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f8fafc;
}

.exwallet-table th {
  padding: 0.9rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}

.exwallet-table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  color: var(--text);
  vertical-align: middle;
}

.exwallet-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.exwallet-table tbody tr:hover {
  background: #f0fdfa !important;
}

.exwallet-table tbody tr:last-child td {
  border-bottom: none;
}

.exwallet-mono {
  font-family: ui-monospace, monospace;
  font-size: 0.8rem;
  color: #0369a1;
  font-weight: 500;
}

.exwallet-chains {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.exwallet-chain-tag {
  display: inline-block;
  padding: 0.3rem 0.6rem;
  background: #e0f2fe;
  color: #0369a1;
  border-radius: 6px;
  font-size: 0.78rem;
  font-weight: 500;
}

.exwallet-empty {
  padding: 2rem 1.5rem;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.9rem;
  margin: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .exwallet-section__header {
    padding: 1rem 1.25rem;
  }

  .exwallet-toolbar {
    flex-direction: column;
    align-items: stretch;
    padding: 1rem 1.25rem;
    gap: 0.75rem;
  }

  .exwallet-chain-form {
    flex-direction: column;
  }

  .exwallet-chain-select,
  .exwallet-chain-input {
    width: 100%;
    min-width: 0;
  }

  .exwallet-search-wrap {
    max-width: none;
  }

  .exwallet-search-input {
    max-width: none;
  }

  .exwallet-table th,
  .exwallet-table td {
    padding: 0.7rem 0.75rem;
    font-size: 0.8rem;
  }

  .exwallet-table th {
    font-size: 0.62rem;
  }

  .exwallet-mono {
    font-size: 0.72rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Exchange/ExchangeWalletPage.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,6DAA6D;EAC7D,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,6CAA6C;EAC7C,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX;;AAEA,eAAe;AACf;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* Exchange Wallet Management */\n.exwallet-section {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid var(--border);\n  overflow: hidden;\n  margin-bottom: 1.5rem;\n}\n\n.exwallet-section:last-child {\n  margin-bottom: 0;\n}\n\n.exwallet-section__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1.25rem 1.5rem;\n  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);\n  border-bottom: 1px solid var(--border);\n}\n\n.exwallet-section__title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.exwallet-section__icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.15);\n  color: #0f766e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n}\n\n.exwallet-section__title {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.exwallet-section__stats {\n  display: flex;\n  gap: 1.25rem;\n}\n\n.exwallet-section__subtitle {\n  margin: 0;\n  padding: 0 1.5rem 1rem;\n  font-size: 0.9rem;\n  color: var(--text-muted);\n}\n\n/* Toolbar: chain form + search in one row */\n.exwallet-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1rem 1.5rem;\n  background: #f8fafc;\n  border-bottom: 1px solid var(--border);\n}\n\n/* Chain list form: dropdown + input + Submit */\n.exwallet-chain-form {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.exwallet-chain-select {\n  padding: 0.6rem 2rem 0.6rem 1rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n  cursor: pointer;\n  min-width: 140px;\n}\n\n.exwallet-chain-select:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.exwallet-chain-input {\n  padding: 0.6rem 1rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n  min-width: 160px;\n}\n\n.exwallet-chain-input::placeholder {\n  color: var(--text-muted);\n}\n\n.exwallet-chain-input:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.exwallet-chain-submit {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 1.25rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  box-shadow: 0 2px 6px rgba(15, 118, 110, 0.3);\n  transition: opacity 0.2s;\n}\n\n.exwallet-chain-submit:hover {\n  opacity: 0.95;\n}\n\n.exwallet-stat {\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n.exwallet-stat strong {\n  color: #0f766e;\n  font-weight: 700;\n  margin-right: 0.25rem;\n}\n\n.exwallet-search-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  flex: 1;\n  min-width: 220px;\n  max-width: 360px;\n}\n\n.exwallet-search-wrap i {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n}\n\n.exwallet-search-input {\n  flex: 1;\n  min-width: 0;\n  max-width: 320px;\n  padding: 0.55rem 0.75rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n}\n\n.exwallet-search-input::placeholder {\n  color: var(--text-muted);\n}\n\n.exwallet-search-input:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.exwallet-table-wrap {\n  overflow-x: auto;\n}\n\n.exwallet-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.exwallet-table thead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #f8fafc;\n}\n\n.exwallet-table th {\n  padding: 0.9rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  border-bottom: 2px solid #e2e8f0;\n  white-space: nowrap;\n}\n\n.exwallet-table td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: var(--text);\n  vertical-align: middle;\n}\n\n.exwallet-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.exwallet-table tbody tr:hover {\n  background: #f0fdfa !important;\n}\n\n.exwallet-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.exwallet-mono {\n  font-family: ui-monospace, monospace;\n  font-size: 0.8rem;\n  color: #0369a1;\n  font-weight: 500;\n}\n\n.exwallet-chains {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.exwallet-chain-tag {\n  display: inline-block;\n  padding: 0.3rem 0.6rem;\n  background: #e0f2fe;\n  color: #0369a1;\n  border-radius: 6px;\n  font-size: 0.78rem;\n  font-weight: 500;\n}\n\n.exwallet-empty {\n  padding: 2rem 1.5rem;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .exwallet-section__header {\n    padding: 1rem 1.25rem;\n  }\n\n  .exwallet-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n    padding: 1rem 1.25rem;\n    gap: 0.75rem;\n  }\n\n  .exwallet-chain-form {\n    flex-direction: column;\n  }\n\n  .exwallet-chain-select,\n  .exwallet-chain-input {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .exwallet-search-wrap {\n    max-width: none;\n  }\n\n  .exwallet-search-input {\n    max-width: none;\n  }\n\n  .exwallet-table th,\n  .exwallet-table td {\n    padding: 0.7rem 0.75rem;\n    font-size: 0.8rem;\n  }\n\n  .exwallet-table th {\n    font-size: 0.62rem;\n  }\n\n  .exwallet-mono {\n    font-size: 0.72rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
